import React, { Component } from 'react';
import { loginActions } from '../../action/loginAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import Footer from '../../Footer/Footer';
import Header from '../../Header/Header';
import HomeSlidTabs from '../Home/HomeSlidTabs';
class PlyerKYCpage extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        // window.setAccordian();
    }
    render() {
        const { t } = this.props;
        const { i18n } = this.props;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket : Player KYC</title>
                    <meta name="description" content="Gulf Ticket PrivacyPolicy" />
                </Helmet>
                }
                <Header />
                <div class="container">
                    <HomeSlidTabs />
                    <div class="rht bg2 content">
                        <div class="staticCont">
                            <h2 class="headding1 padding-top-0">GULFTICKET KNOW YOUR CUSTOMER (KYC) POLICY</h2>
                            <h4 class="padding-top-20 padding-bottom-20">Last Updated: 19th June 2025</h4>

                            <h3 class="padding-bottom-20">1. PURPOSE</h3>
                            <p>Gulfticket is committed to upholding the highest standards in player verification, customer due diligence (CDD), and anti-fraud protocols. Our Know Your Customer (KYC) policy ensures:</p>
                            <div class="staticContLi">
                                <ul>
                                    <li>Regulatory compliance with global AML/CTF laws and the Gambling Control Authority (GCA) of Samoa</li>
                                    <li>Prevention of identity theft, financial fraud, and underage gambling</li>
                                    <li>Protection of customers and the integrity of our platform</li>
                                </ul>
                            </div>

                            <h3 class="padding-bottom-20">2. KYC REQUIREMENTS & TIMING</h3>
                            <p><strong>When KYC Is Required:</strong></p>
                            <div class="staticContLi">
                                <ul>
                                    <li>Upon account registration (soft verification)</li>
                                    <li>Before first withdrawal</li>
                                    <li>Upon reaching defined deposit or withdrawal thresholds</li>
                                    <li>As part of routine or enhanced due diligence (EDD)</li>
                                    <li>On suspicion of fraudulent or unusual activity</li>
                                </ul>
                            </div>
                            <p><strong>Documents We May Request:</strong></p>
                            <div class="staticContLi">
                                <strong>Identity Verification:</strong>
                                {/* <strong>Address Verification:</strong>
                        <strong>Payment Verification:</strong> */}
                                <div class="staticContLi">
                                    <ul>
                                        <li> Valid government-issued ID (passport, national ID, or driver’s licence)</li>
                                        <li> Selfie or video confirmation to verify biometric match</li>

                                    </ul>
                                </div>
                            </div>
                            <div class="staticContLi">
                                {/* <strong>Identity Verification:</strong> */}
                                <strong>Address Verification:</strong>
                                {/* <strong>Payment Verification:</strong> */}
                                <div class="staticContLi">
                                    <ul>

                                        <li> Utility bill, bank statement, or government letter (dated within last 3 months) </li>
                                        <li> showing full name, residential address, and date </li>
                                        {/* <li> Copy of debit/credit card (first 4 and last 4 digits visible; middle 8 digits and CVV obscured); E-wallet screenshot with email and account holder’s name</li>
                            <li>  Bank statement showing account holder name and recent transactions</li>
                            <li> E-wallet screenshot with email and account holder’s name</li> */}
                                    </ul>
                                </div>
                            </div>

                            <div class="staticContLi">

                                <strong>Payment Verification:</strong>
                                <div class="staticContLi">
                                    <ul>
                                        <li> Copy of debit/credit card (first 4 and last 4 digits visible; middle 8 digits and CVV obscured)</li>
                                        <li>  Bank statement showing account holder name and recent transactions</li>
                                        <li> E-wallet screenshot with email and account holder’s name</li>

                                    </ul>
                                </div>
                            </div>


                            <h3 class="padding-bottom-20">3. VERIFICATION PROCESS</h3>
                            <div class="staticContLi">
                                <ul>
                                    <p>1. Upload documents via your secure account portal</p>
                                    <p>2. Documents must be clear, legible, and show all edges</p>
                                    <p>3. Verification typically completed within 24–48 hours</p>
                                    <p>4. Customers are notified via email of verification outcome</p>
                                </ul>
                                <p>We reserve the right to request additional documentation or conduct interviews where necessary to complete KYC.</p>
                            </div>

                            <h3 class="padding-bottom-20">4. DATA HANDLING & SECURITY</h3>
                            <div class="staticContLi">
                                <ul>
                                    <li>All submitted documents are stored securely using industry-standard encryption</li>
                                    <li>Only authorised compliance personnel can access your information</li>
                                    <li>Data is retained for a minimum of 5 years in accordance with applicable laws</li>
                                    <li>We will never sell, misuse, or expose your personal information to third parties without legal basis</li>
                                </ul>
                            </div>

                            <h3 class="padding-bottom-20">5. ENHANCED DUE DILIGENCE (EDD)</h3>
                            <p><strong>EDD may apply in the following cases:</strong></p>
                            <div class="staticContLi">
                                <ul>
                                    <li>Cumulative deposits/withdrawals exceed $10,000 USD</li>
                                    <li>Large single transactions or multiple quick deposits</li>
                                    <li>Use of payment methods not matching registered details</li>
                                    <li>Players flagged as politically exposed persons (PEPs)</li>
                                    <li>High-risk jurisdiction users</li>
                                </ul>
                            </div>
                            <p><strong>EDD steps may include:</strong></p>
                            <div class="staticContLi">
                                <ul>
                                    <li>Source of funds/wealth verification</li>
                                    <li>Additional identity and address documentation</li>
                                    <li>Notarised document submission for payouts over $100,000 USD</li>
                                    <li>Compliance team review and approval</li>
                                </ul>
                            </div>

                            <h3 class="padding-bottom-20">6. UNDERAGE GAMING PREVENTION</h3>
                            <div class="staticContLi">
                                <p>Gulfticket strictly prohibits anyone under the age of 18 from opening or operating an account. We implement:</p>
                                <div class="staticContLi">
                                    <ul>
                                        <li>Electronic ID validation and age checks</li>
                                        <li>Randomised re-verification processes</li>
                                        <li>Account suspension if underage use is suspected or verified</li>
                                    </ul>
                                </div>
                            </div>

                            <h3 class="padding-bottom-20">7. KYC FAILURE OR REFUSAL</h3>
                            <p>Failure to complete KYC may result in:</p>
                            <div class="staticContLi">
                                <ul>
                                    <li>Account suspension or limitation</li>
                                    <li>Denial of withdrawals or bonuses</li>
                                    <li>Permanent account closure (for fraudulent documents or behavior)</li>
                                </ul>
                                <p>Customers will be informed of next steps or appeals via registered email</p>
                            </div>

                            <h3 class="padding-bottom-20">8. CONTACT & SUPPORT</h3>
                            <p>For KYC queries or help uploading documents:</p>
                            <p>Email: <a href="mailto:kyc@gulfticket.com">kyc@gulfticket.com</a></p>
                            <p>Support Portal: 24/7 Live Chat available through your account</p>

                            <p>We appreciate your cooperation in helping us maintain a secure and compliant platform. Your privacy and safety remain our top priority.</p>
                        </div>
                        <Footer />
                    </div>
                </div>


            </>
        );
    }
}
function mapStateToProps(state) {
    const { user } = state.loginReducer;
    return { user };
}
const mapActionToProps = {
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(PlyerKYCpage))